import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
	Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);
//中英文切换
let meteData = '';
if(sessionStorage.getItem('lang') === 'cn') {
	meteData = 'i-Membrane';
}else if(sessionStorage.getItem('lang') === 'en') {
	meteData = 'English';
}else {
	meteData = 'i-Membrane';
}
export default new Router({
	mode: 'history',
	/* scrollBehavior(to, from, savePosition) {
		if(savePosition){
			return savePosition
		}else{
			return { x: 0, y: 0 }
		}
	}, */
	routes: [
		{path: '*', redirect: '/index.html'},
		{  //首页
			path: '/index.html',
			name: 'Index',
			component: resolve => require(['@/pages/pc/index/index'], resolve),
			meta: {
				title: meteData,
				content: {
					keywords: 'i-Membrane',
					description: 'i-Membrane',
					author: meteData,
				},
				requireAuth: true,
			},
		},
	]
})
